<template>
    <div class="about">
        <!-- 页面标题 -->
        <div class="page-header">
            <h1>关于我们</h1>
            <p>专注软件开发，助力企业数字化转型</p>
        </div>

        <!-- 公司简介 -->
        <div class="section company-intro">
            <el-row :gutter="40">
                <el-col :span="12">
                    <div class="intro-content">
                        <h2>公司简介</h2>
                        <p>我们是一家专注于软件开发的技术公司，致力于为企业提供全方位的数字化解决方案。自成立以来，我们始终坚持"以客户为中心，以技术为驱动"的理念，为客户提供专业、高效、可靠的软件开发服务。</p>
                        <div class="company-stats">
                            <div class="stat-item">
                                <h3>10+</h3>
                                <p>行业经验</p>
                            </div>
                            <div class="stat-item">
                                <h3>100+</h3>
                                <p>成功案例</p>
                            </div>
                            <div class="stat-item">
                                <h3>50+</h3>
                                <p>专业团队</p>
                            </div>
                        </div>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div class="intro-image">
                        <img src="@/assets/images/company.png" alt="公司简介">
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 我们的优势 -->
        <div class="section advantages">
            <h2 class="section-title">我们的优势</h2>
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="6" v-for="advantage in advantages" :key="advantage.id">
                    <div class="advantage-card">
                        <el-icon :size="40"><component :is="advantage.icon" /></el-icon>
                        <h3>{{ advantage.title }}</h3>
                        <p>{{ advantage.description }}</p>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 发展历程 -->
        <div class="section history">
            <h2 class="section-title">发展历程</h2>
            <el-timeline>
                <el-timeline-item
                    v-for="(activity, index) in history"
                    :key="index"
                    :timestamp="activity.time"
                    :type="activity.type">
                    <h3>{{ activity.title }}</h3>
                    <p>{{ activity.content }}</p>
                </el-timeline-item>
            </el-timeline>
        </div>

        <!-- 联系我们 -->
        <div class="section contact">
            <h2 class="section-title">联系我们</h2>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="24" :md="12">
                    <div class="contact-info">
                        <div class="info-item">
                            <el-icon><Location /></el-icon>
                            <span>地址：江西省吉安市</span>
                        </div>
                        <div class="info-item">
                            <el-icon><Phone /></el-icon>
                            <span>电话：135-3767-0367</span>
                        </div>
                        <div class="info-item">
                            <el-icon><Message /></el-icon>
                            <span>邮箱：xly315617043@163.com</span>
                        </div>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12">
                    <div class="contact-form">
                        <el-form>
                            <el-form-item>
                                <el-input placeholder="您的姓名"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input placeholder="联系电话"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-input type="textarea" placeholder="请输入您的留言"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" class="submit-btn">提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { Location, Phone, Message } from '@element-plus/icons-vue'

export default {
    name: 'About',
    components: {
        Location,
        Phone,
        Message
    },
    data() {
        return {
            advantages: [
                {
                    icon: 'Monitor',
                    title: '技术实力',
                    description: '拥有专业的研发团队，掌握前沿技术，能够提供全方位的技术解决方案'
                },
                {
                    icon: 'Service',
                    title: '优质服务',
                    description: '7*24小时技术支持，快速响应客户需求，提供专业的技术咨询服务'
                },
                {
                    icon: 'Medal',
                    title: '品质保证',
                    description: '严格的质量管理体系，确保每个项目都达到最高标准'
                }
            ],
            history: [
                {
                    time: '2023年',
                    title: '业务扩展',
                    content: '成功开拓海外市场，服务范围扩展至全球多个国家和地区',
                    type: 'primary'
                },
                {
                    time: '2021年',
                    title: '技术升级',
                    content: '引入人工智能技术，推出智能化解决方案',
                    type: 'success'
                },
                {
                    time: '2019年',
                    title: '公司成立',
                    content: '公司正式成立，开始提供软件开发服务',
                    type: 'info'
                }
            ]
        }
    }
}
</script>

<style scoped>
.about {
    padding: 0;
    margin-top: 80px;
}

.page-header {
    background: linear-gradient(135deg, #409EFF 0%, #36D1DC 100%);
    color: white;
    padding: 60px 0;
    text-align: center;
}

.page-header h1 {
    font-size: 36px;
    margin-bottom: 20px;
}

.section {
    padding: 60px 20px;
}

.section-title {
    text-align: center;
    margin-bottom: 40px;
    font-size: 32px;
    color: #2c3e50;
}

/* 公司简介样式 */
.company-intro {
    background-color: #f9fafc;
}

.intro-content {
    padding: 20px;
}

.intro-content h2 {
    font-size: 28px;
    margin-bottom: 20px;
    color: #2c3e50;
}

.intro-content p {
    font-size: 16px;
    line-height: 1.8;
    color: #666;
    margin-bottom: 30px;
}

.company-stats {
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
}

.stat-item {
    text-align: center;
}

.stat-item h3 {
    font-size: 36px;
    color: #409EFF;
    margin-bottom: 10px;
}

.intro-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
}

/* 优势卡片样式 */
.advantage-card {
    background: white;
    padding: 30px 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    height: 100%;
}

.advantage-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.advantage-card .el-icon {
    color: #409EFF;
    margin-bottom: 20px;
}

.advantage-card h3 {
    font-size: 20px;
    color: #2c3e50;
    margin-bottom: 15px;
}

.advantage-card p {
    color: #666;
    line-height: 1.6;
    font-size: 14px;
}

/* 发展历程样式 */
.history {
    background-color: #f9fafc;
}

.el-timeline {
    padding: 20px;
}

/* 联系我们样式 */
.contact-info {
    padding: 20px;
    margin-bottom: 20px;
}

.info-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
    color: #2c3e50;
}

.info-item .el-icon {
    margin-right: 10px;
    color: #409EFF;
    font-size: 20px;
}

.contact-form {
    padding: 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.contact-form .el-form-item {
    margin-bottom: 20px;
}

.submit-btn {
    width: 100%;
}

/* 响应式布局 */
@media (max-width: 768px) {
    .contact-info {
        padding: 15px;
        margin-bottom: 15px;
    }

    .info-item {
        margin-bottom: 15px;
        font-size: 14px;
    }

    .info-item .el-icon {
        font-size: 18px;
    }

    .contact-form {
        padding: 15px;
    }

    .contact-form .el-form-item {
        margin-bottom: 15px;
    }

    .el-input__inner {
        height: 40px;
    }

    .el-textarea__inner {
        min-height: 100px;
    }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
    .contact-info {
        padding: 12px;
        margin-bottom: 12px;
    }

    .info-item {
        margin-bottom: 12px;
        font-size: 13px;
    }

    .info-item .el-icon {
        font-size: 16px;
    }

    .contact-form {
        padding: 12px;
    }

    .contact-form .el-form-item {
        margin-bottom: 12px;
    }

    .el-input__inner {
        height: 36px;
    }

    .el-textarea__inner {
        min-height: 80px;
    }
}
</style>
